module.exports = __webpack_public_path__ + "VIPV7.png?8eaa92f1f14c14c242a912ee17dfd9ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV7.png
// module id = 140
// module chunks = 0